import { get, post, put, deleteRequest } from "../helpers/apihelpers";
// import { deleteRequest, get, post, postfd, publicPost, put } from "../helpers/apihelpers";

// ✅ Get all Google Drive credentials
export const getDriveCredentials = async () => {
  try {
    const response = await get('/api/drive-credentials');
    return response.data;
  } catch (error) {
    console.error('Error fetching drive credentials:', error);
    throw error;
  }
};

// ✅ Add new credentials (optional)
export const addDriveCredential = async (data) => {
  try {
    const response = await post('/api/drive-credentials', data);
    return response.data;
  } catch (error) {
    console.error('Error adding drive credential:', error);
    throw error;
  }
};

// ✅ Update credentials (optional)
export const updateDriveCredential = async (id, data) => {
  try {
    const response = await put(`/api/drive-credentials/${id}`, data);
    return response.data;
  } catch (error) {
    console.error('Error updating drive credential:', error);
    throw error;
  }
};

// ✅ Delete credentials (optional)
export const deleteDriveCredential = async (id) => {
  try {
    const response = await deleteRequest(`/api/drive-credentials/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting drive credential:', error);
    throw error;
  }
};